import { createTheme } from '@mui/material/styles';

export const COLORS = {
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    PRIMARY: '#000000',
    ICE: '#F5F9F9',
    LIGHTGRAY: '#B1BFC4',
    GRAY: '#687980',
    RED: '#C30023'
}

export const BORDER_RADIUS = 30

export const muiTheme = createTheme({
    palette: {
        common: {
            black: '#000000',
            white: '#FFFFFF',
        },
        primary: {
            main: '#000000'
        },
        secondary: {
            main: '#FFFFFF'
        },
        contrastThreshold: 2,
        background: {
            default: '#FFFFFF',
        },
        info: {
            main: COLORS.ICE
        }
    },
    typography: {
        h1: {
            fontFamily: 'Gilroy-Bold',
            fontSize: 40
        },
        h2: {
            fontFamily: 'Gilroy-Bold',
            fontSize: 32,
        },
        h3: {
            fontFamily: 'Gilroy-Bold',
            fontSize: 24,
        },
        h4: {
            fontFamily: 'Gilroy-Bold',
            fontSize: 20,
        },
        h5: {
            fontFamily: 'Gilroy-Bold',
            fontSize: 16,
            padding: 0
        },
        body1: {
            fontFamily: 'ProximaNova',
            fontSize: 16,
        },
        fontFamily: 'ProximaNova'
    },
    shape: {
        borderRadius: 10
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontFamily: 'Gilroy-SemiBold'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    textTransform: 'none'
                },
                contained: {
                    boxShadow: 'none',
                    textTransform: 'none',
                    backgroundColor: COLORS.PRIMARY
                },
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                }
            }
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    zIndex: '100'
                }
            }
        }
    }
});